// Fix es6 feature on old browser
import 'babel-polyfill'


import Vue from 'vue'
import App from './scripts/components/app-main'


// Globals components

import './scripts/mixins/core-event-hub'


// Start application

/* eslint-disable no-new */
new Vue(App).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js